<svg [ngClass]="class" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_5906_19857)">
    <path d="M17.3367 18.6637L12.1842 13.5L17.3367 8.33625L15.7505 6.75L9.00049 13.5L15.7505 20.25L17.3367 18.6637Z" fill="#372121"/>
  </g>
  <defs>
    <clipPath id="clip0_5906_19857">
      <rect width="27" height="27" fill="white"/>
    </clipPath>
  </defs>
</svg>

